{
  "top-salons-city-page": {
    "text": {
      "no-salon-found": "Aucun salon trouvé dans cette ville pour le moment."
    },
    "meta": {
      "title": "Meilleurs salons à {{ city }}",
      "description": "Découvrez et réservez les meilleurs salons de beauté à {{ city }}. Comparez les meilleurs salons, vérifiez les disponibilités et réservez votre rendez-vous en ligne en quelques minutes."
    }
  }
}
